import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=3f66e1d6"
import script from "./CommonButton.vue?vue&type=script&lang=js"
export * from "./CommonButton.vue?vue&type=script&lang=js"
import style0 from "./CommonButton.vue?vue&type=style&index=0&id=3f66e1d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports